var e = e || {};
var fcm = {};
var Instafeed = Instafeed || {};
( function () {
    'use strict';
    jQuery( function () {
        fcm.nav();
        fcm.thumbs();
        fcm.contentboxes();
        fcm.vendor.init();
    } );
    e.constant.jWindow.on( 'load', function () {
        fcm.oddset();
    } );
    fcm.oddset = function () {
        jQuery( '.fcm-oddset' ).attr( 'src', function () {
            return this.getAttribute( 'data-src' );
        } );
    };
    fcm.nav = function () {
        jQuery( document ).on( 'click', '.js-fcm-toggle-nav', function () {
            jQuery( 'body' ).toggleClass( 'fcm-nav-phone-open' );
        } );
    };
    fcm.thumbs = function () {
        jQuery( document ).on( 'click', '.js-e-carousel-compact-thumbs li a', function () {
            window.location.href = $( this ).attr( 'href' );
        } );
    };
    fcm.vendor = {};
    fcm.vendor.init = function () {
        if ( jQuery( '.instagram-feed' ).length ) {
            fcm.vendor.instagram();
        }
    };
    fcm.contentboxes = function () {
        if ( e.constant.jWindow.width() > 764 ) {
            if ( jQuery( '.autoheight' ).length ) {
                jQuery( '.autoheight' ).parent( '.row' ).addClass( 'js-content-row' );
                var jRow = jQuery( '.js-content-row' );
                setTimeout( function () {
                    jRow.each( function () {
                        var jSetpiece = jSetpiece > jQuery( this ).height() ? jSetpiece : jQuery( this ).height();
                        jQuery( this ).find( '.autoheight' ).each( function () {
                            jQuery( this ).css( {
                                'min-height': jSetpiece + 28
                            } );
                        } );
                        jQuery( this ).find( '.stacked' ).each( function () {
                            jQuery( this ).css( {
                                'height': jSetpiece / 2
                            } );
                        } );
                    } );
                }, 100 );
            }
        }
    };
    fcm.vendor.instagram = function () {
        var jFeed = jQuery( '.instagram-feed' ),
            jLimit = parseInt( jFeed.data( 'limit' ) ),
            jCaption = jFeed.data( 'caption' ),
            jCaptions = '',
            jUserType = jFeed.data( 'type' ),
            //jUserTypes = '',
            jGet = 'user',
            jUser = jFeed.data( 'user' ),
            jToken = jFeed.data( 'token' ),
            jTagged = jFeed.data( 'tags' );
        if ( jCaption === 'True' ) {
            jCaptions = '<div class="instagram-feed-item-caption"><p>{{caption}}</p></div>';
        }
        if ( jUserType === 'True' ) {
            jGet = 'tagged';
        }
        var i = new Instafeed( {
            get: jGet,
            tagName: jTagged,
            userId: jUser,
            accessToken: jToken,
            limit: jLimit,
            success: function ( data ) {
                if ( jGet === 'user' ) {
                    jTagged = data.data[ 0 ].user.username;
                }
            },
            after: function () {
                jQuery( '.instagram-feed-item' ).each( function ( i ) {
                    jQuery( this ).addClass( 'instagram-feed-item-' + i );
                } );
                jQuery( '.instagram-feed-item' );
                jQuery( '#instagram-feed' ).prepend( '<div class="instagram-feed-item tag"><img src="/Files/Templates/Designs/fcm-fodbold/assets/img/trans.png"><i class="icon-instagram">' + '<span> <strong>@</strong>' + jTagged + '</span>' + '</i></div>' );
            },
            target: 'instagram-feed',
            resolution: 'standard_resolution',
            template: '<div class="instagram-feed-item"><a href="{{link}}" target="_blank"><img src="{{image}}" title="{{caption}}"/>' + jCaptions + '</a></div>'
        } );
        i.run();
    };
}() );